import { render, staticRenderFns } from "./JZJL.vue?vue&type=template&id=2892ea5d&scoped=true&"
import script from "./JZJL.vue?vue&type=script&lang=js&"
export * from "./JZJL.vue?vue&type=script&lang=js&"
import style0 from "./JZJL.vue?vue&type=style&index=0&id=2892ea5d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2892ea5d",
  null
  
)

export default component.exports